export default __webpack_public_path__ + "static/media/FIU_Honors.00eb10dd.svg";